import { render, staticRenderFns } from "./SystemsListPanel.vue?vue&type=template&id=480b9d39&"
import script from "./SystemsListPanel.vue?vue&type=script&lang=js&"
export * from "./SystemsListPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports